import { useDarkMode } from "../../../context/ThemeContext";
import { getThemeClasses } from "../../../utils/ThemeClasses";

export default function ResumenSection() {
  const { isDarkMode } = useDarkMode();
  const themeClasses = getThemeClasses(isDarkMode);

  return (
    <div className="w-full h-full p-4 sm:p-6 overflow-auto">
      {/* Page Header */}
      <div className="mb-4 sm:mb-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
          <div>
            <h1 className={`text-xl sm:text-2xl font-bold ${themeClasses.text}`}>
              Facturación
            </h1>
            <p className={`text-xs sm:text-sm ${themeClasses.textSecondary} mt-1`}>
              Gestiona tus pagos, facturas y métodos de pago
            </p>
          </div>
          <button className="w-full sm:w-auto flex items-center justify-center space-x-2 px-4 py-2 bg-primary-500 hover:bg-primary-400 text-gray-900 rounded-xl transition-all font-medium shadow-lg text-sm sm:text-base">
            <i className="ri-download-line"></i>
            <span>Descargar factura</span>
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
        <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4`}>
          <div className="flex items-center justify-between mb-2">
            <span className={`text-sm ${themeClasses.textSecondary}`}>Balance actual</span>
            <div className="w-8 h-8 bg-primary-500/10 rounded-lg flex items-center justify-center">
              <i className="ri-wallet-3-line text-primary-500"></i>
            </div>
          </div>
          <p className={`text-lg sm:text-2xl font-bold ${themeClasses.text}`}>$0.00</p>
          <p className="text-xs text-primary-500 mt-1">Sin saldo pendiente</p>
        </div>

        <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4`}>
          <div className="flex items-center justify-between mb-2">
            <span className={`text-sm ${themeClasses.textSecondary}`}>Próximo pago</span>
            <div className="w-8 h-8 bg-purple-500/10 rounded-lg flex items-center justify-center">
              <i className="ri-calendar-line text-purple-500"></i>
            </div>
          </div>
          <p className={`text-lg sm:text-2xl font-bold ${themeClasses.text}`}>--</p>
          <p className={`text-xs ${themeClasses.textSecondary} mt-1`}>Sin pagos programados</p>
        </div>

        <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4`}>
          <div className="flex items-center justify-between mb-2">
            <span className={`text-sm ${themeClasses.textSecondary}`}>Total pagado</span>
            <div className="w-8 h-8 bg-blue-500/10 rounded-lg flex items-center justify-center">
              <i className="ri-money-dollar-circle-line text-blue-500"></i>
            </div>
          </div>
          <p className={`text-lg sm:text-2xl font-bold ${themeClasses.text}`}>$0.00</p>
          <p className={`text-xs ${themeClasses.textSecondary} mt-1`}>Este mes</p>
        </div>

        <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4`}>
          <div className="flex items-center justify-between mb-2">
            <span className={`text-sm ${themeClasses.textSecondary}`}>Facturas</span>
            <div className="w-8 h-8 bg-orange-500/10 rounded-lg flex items-center justify-center">
              <i className="ri-file-list-3-line text-orange-500"></i>
            </div>
          </div>
          <p className={`text-lg sm:text-2xl font-bold ${themeClasses.text}`}>0</p>
          <p className={`text-xs ${themeClasses.textSecondary} mt-1`}>Facturas generadas</p>
        </div>
      </div>

      {/* Current Invoice Card */}
      <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4 sm:p-6 mb-4 sm:mb-6`}>
        <div className="flex items-start justify-between mb-2">
          <div>
            <p className={`text-sm ${themeClasses.textSecondary}`}>Factura actual</p>
            <p className={`text-xl sm:text-3xl font-bold ${themeClasses.text} mt-1`}>$2,847.00 MXN</p>
            <div className="flex items-center space-x-2 mt-2">
              <span className="text-xs font-medium text-red-500 bg-red-500/10 px-2 py-0.5 rounded">Vencido</span>
              <span className={`text-xs ${themeClasses.textSecondary}`}>- Vence el 15 de mayo, 2024</span>
            </div>
          </div>
          <div className="w-10 h-10 bg-red-500/10 rounded-lg flex items-center justify-center">
            <i className="ri-error-warning-line text-red-500 text-xl"></i>
          </div>
        </div>

        {/* Warning Banner */}
        <div className="bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/30 rounded-xl p-4 mt-4">
          <div className="flex items-start space-x-3">
            <i className="ri-error-warning-fill text-red-500 text-lg mt-0.5"></i>
            <div>
              <p className="text-sm font-medium text-red-600 dark:text-red-400">Pago vencido - Acción requerida</p>
              <p className={`text-xs ${themeClasses.textSecondary} mt-1`}>
                Tu cuenta tiene un saldo pendiente. Para evitar la suspensión del servicio, por favor realiza el pago lo antes posible o actualiza tu método de pago.
              </p>
            </div>
          </div>
        </div>

        {/* Plan Details Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mt-4 sm:mt-6 pt-4 sm:pt-6 border-t border-gray-200 dark:border-gray-700">
          <div>
            <p className={`text-xs ${themeClasses.textSecondary}`}>Plan actual</p>
            <p className={`text-sm font-medium ${themeClasses.text} mt-1`}>Enterprise - 150 vehículos</p>
          </div>
          <div>
            <p className={`text-xs ${themeClasses.textSecondary}`}>Periodo de facturación</p>
            <p className={`text-sm font-medium ${themeClasses.text} mt-1`}>Mensual</p>
          </div>
          <div>
            <p className={`text-xs ${themeClasses.textSecondary}`}>Método de pago</p>
            <div className="flex items-center space-x-2 mt-1">
              <div className="w-8 h-5 bg-blue-600 rounded flex items-center justify-center">
                <span className="text-white text-[8px] font-bold">VISA</span>
              </div>
              <span className={`text-sm ${themeClasses.text}`}>•••• 4242</span>
              <span className="text-xs text-red-500">Expirada</span>
            </div>
          </div>
          <div>
            <p className={`text-xs ${themeClasses.textSecondary}`}>Próximo cobro</p>
            <p className={`text-sm font-medium ${themeClasses.text} mt-1`}>15 de junio, 2024</p>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap items-center gap-3 mt-6">
          <button className="flex-1 sm:flex-none flex items-center justify-center space-x-2 px-6 py-3 bg-primary-500 hover:bg-primary-400 text-gray-900 rounded-xl transition-all font-medium">
            <i className="ri-bank-card-line"></i>
            <span>Pagar ahora</span>
          </button>
          <button className={`flex-1 sm:flex-none flex items-center justify-center space-x-2 px-6 py-3 border ${themeClasses.cardBorder} rounded-xl ${themeClasses.buttonText} ${themeClasses.buttonHover} transition-all font-medium`}>
            <i className="ri-refresh-line"></i>
            <span>Actualizar método de pago</span>
          </button>
        </div>
      </div>

      {/* Invoice Breakdown */}
      <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4 sm:p-6`}>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0 mb-4 sm:mb-6">
          <h2 className={`text-base sm:text-lg font-semibold ${themeClasses.text}`}>
            Desglose de factura
          </h2>
          <button className="text-sm text-primary-500 hover:text-[var(--brand-primary-hover)] font-medium">
            Ver detalles completos
          </button>
        </div>

        {/* Line Items */}
        <div className="space-y-4">
          <div className="flex items-center justify-between py-3 border-b border-gray-100 dark:border-gray-700">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center">
                <i className={`ri-truck-line text-lg ${themeClasses.textSecondary}`}></i>
              </div>
              <div>
                <p className={`text-sm font-medium ${themeClasses.text}`}>Plan Enterprise</p>
                <p className={`text-xs ${themeClasses.textSecondary}`}>150 vehículos - Mayo 2024</p>
              </div>
            </div>
            <p className={`text-sm font-semibold ${themeClasses.text}`}>$2,400.00</p>
          </div>

          <div className="flex items-center justify-between py-3 border-b border-gray-100 dark:border-gray-700">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center">
                <i className={`ri-radar-line text-lg ${themeClasses.textSecondary}`}></i>
              </div>
              <div>
                <p className={`text-sm font-medium ${themeClasses.text}`}>Telemetría avanzada</p>
                <p className={`text-xs ${themeClasses.textSecondary}`}>20 dispositivos adicionales</p>
              </div>
            </div>
            <p className={`text-sm font-semibold ${themeClasses.text}`}>$320.00</p>
          </div>

          <div className="flex items-center justify-between py-3 border-b border-gray-100 dark:border-gray-700">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center">
                <i className={`ri-headphone-line text-lg ${themeClasses.textSecondary}`}></i>
              </div>
              <div>
                <p className={`text-sm font-medium ${themeClasses.text}`}>Soporte prioritario</p>
                <p className={`text-xs ${themeClasses.textSecondary}`}>24/7 - Incluido en plan</p>
              </div>
            </div>
            <p className={`text-sm font-semibold ${themeClasses.text}`}>$0.00</p>
          </div>

          <div className="flex items-center justify-between py-3 border-b border-gray-100 dark:border-gray-700">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gray-100 dark:bg-gray-800 rounded-lg flex items-center justify-center">
                <i className={`ri-percent-line text-lg ${themeClasses.textSecondary}`}></i>
              </div>
              <div>
                <p className={`text-sm font-medium ${themeClasses.text}`}>IVA (16%)</p>
                <p className={`text-xs ${themeClasses.textSecondary}`}>Impuesto aplicado</p>
              </div>
            </div>
            <p className={`text-sm font-semibold ${themeClasses.text}`}>$435.20</p>
          </div>
        </div>

        {/* Total */}
        <div className="flex items-center justify-between mt-6 pt-4 border-t-2 border-gray-200 dark:border-gray-600">
          <p className={`text-base font-medium ${themeClasses.text}`}>Total a pagar</p>
          <p className={`text-lg sm:text-xl font-bold ${themeClasses.text}`}>$3,155.20 MXN</p>
        </div>
      </div>
    </div>
  );
}
